/**
 * tm/components/CollectLinkPicker.tsx — 업무 등록 때 자료수집 단계 「새로 만들기 / 기존 자료 요청 잇기」 (2026-10-28 지도사 「등록할 때 자료수집은 기존 프로젝트 잇기 선택 가능해야」)
 *  고른 업체에 아직 업무에 안 이어진 자료수집이 있을 때만 보인다 · 고르면 서버(POST /tasks)가 그 단계에 잇는다(extras.link_project_id · 링크 · 받은 자료는 그대로)
 *  PC(업무 등록 창)와 휴대폰(업무 추가) 함께 — look 으로 모양만 다르게
 */
import { useEffect, useState } from 'react';
import { unlinkedCollects } from '../api';
import type { UnlinkedCollect } from '../api';

const md = (v: string | null | undefined) => { const d = String(v || '').slice(0, 10); return d.length === 10 ? `${+d.slice(5, 7)}/${+d.slice(8, 10)}` : ''; };
export const collectLabel = (c: UnlinkedCollect) => `${c.project}${c.items ? ` · 항목 ${c.items}개` : ''}${md(c.created_at) ? ` · ${md(c.created_at)} 만듦` : ''}`;

export default function CollectLinkPicker({ companyId, value, onChange, look = 'pc' }: {
  companyId: string; value: string; onChange: (id: string, label: string) => void; look?: 'pc' | 'mobile';
}) {
  const [list, setList] = useState<UnlinkedCollect[] | null>(null);
  useEffect(() => {
    let alive = true;
    setList(null);
    if (!companyId) { setList([]); return undefined; }
    void unlinkedCollects(companyId).then(l => { if (alive) setList(l); });
    return () => { alive = false; };
  }, [companyId]);
  // 고른 업체가 바뀌어 목록에 없는 것을 골라 둔 채면 풀어 준다(다른 업체 자료수집을 잇지 않게)
  useEffect(() => { if (list && value && !list.some(x => x.id === value)) onChange('', ''); }, [list, value, onChange]);
  if (!list || !list.length) return null;
  const opts = [{ id: '', label: '새로 만들기' }, ...list.map(c => ({ id: c.id, label: collectLabel(c) }))];
  if (look === 'mobile') {
    return (
      <div role="radiogroup" aria-label="자료 요청" style={{ display: 'grid', gap: 8 }}>
        {opts.map(o => {
          const on = o.id === value;
          return (
            <button key={o.id || 'new'} type="button" role="radio" aria-checked={on} className="tds-btn" onClick={() => onChange(o.id, o.id ? o.label : '')}
              style={{ minHeight: 52, padding: '8px 14px', borderRadius: 14, border: `1.5px solid ${on ? '#3182F6' : '#D1D6DB'}`, background: on ? '#E8F3FF' : '#fff', color: on ? '#1B64DA' : '#333D4B', fontSize: 16, fontWeight: on ? 700 : 500, textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit', wordBreak: 'keep-all' }}>
              {o.id ? `잇기 · ${o.label}` : '새로 만들기 (자료수집 설정에서)'}
            </button>
          );
        })}
      </div>
    );
  }
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#374151' }}>
      <span style={{ fontWeight: 600, flexShrink: 0 }}>자료 요청</span>
      <select value={value} onChange={e => { const o = opts.find(x => x.id === e.target.value); onChange(e.target.value, o && o.id ? o.label : ''); }}
        style={{ flex: 1, minWidth: 0, padding: '5px 8px', borderRadius: 6, border: '1px solid #D1D5DB', fontSize: 12, background: '#fff', color: '#1F2937' }}>
        {opts.map(o => <option key={o.id || 'new'} value={o.id}>{o.id ? `기존 잇기 · ${o.label}` : '새로 만들기'}</option>)}
      </select>
    </label>
  );
}
